import EmptyState from "../components/shared/EmptyState";
import ErrorState from "../components/shared/ErrorState";
import LoadingState from "../components/shared/LoadingState";
import ResultsTable from "../components/results/ResultsTable";
import { Container } from "@mui/material";
import { hasVisibleRoundResults, isCompetitionVisibleInResults } from "../utils/resultPublicationUtils";
import { useNavigationHelper } from "../hooks/useNavigationHelper";
import { useRoundContext } from "../contexts/RoundContext";

export default function ResultsView() {
  const { round, competition, category, loading, error } = useRoundContext();
  const { goBack } = useNavigationHelper();

  const handleBack = () => {
    if (competition && category) {
      goBack();
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie wyników..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} />
      </Container>
    );
  }

  if (
    !competition ||
    !category ||
    !round ||
    !isCompetitionVisibleInResults(competition) ||
    !hasVisibleRoundResults(competition, category)
  ) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message="Dla tej rundy nie opublikowano wyników" />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <ResultsTable
        results={round.results}
        roundType={round.type}
        roundName={round.name}
        categoryName={category.name}
        judges={round.judges}
        onBack={handleBack}
      />
    </Container>
  );
}
